export default "__VITE_ASSET__540b7586__"